<template>
    <div class="info-modal">
        <modal :display="modalStatus.walletStoredInfo" @modalStatus="closeModal" >
            <h1>儲值</h1>
            <div class="content">
                <h2>選擇付款方式</h2>
                <div class="type">
                    <img src="@/assets/img/icon/atm_orange.svg" alt="" srcset="">
                    <div class="content-wrap">
                        <div class="title">
                            匯款帳號
                        </div>
                    </div>
                </div>
                <div class="notice-title">
                    <img src="@/assets/img/icon/info_gray.svg" alt="" >
                    注意事項
                </div>
                <div class="notice-content">下列是您個人的專屬匯款帳號，請到銀行進行匯款即可完成儲值</div>
                <div class="list-wrap">
                    <div class="list">
                        <span class="title">銀行名稱</span>
                        <span class="info">：{{userBankAccountInfo.bankName}}</span>
                    </div>
                    <div class="list">
                        <span class="title">銀行代號</span>
                        <span class="info">：{{userBankAccountInfo.bankCode}}</span>
                    </div>
                    <div class="list">
                        <span class="title">匯款帳號</span>
                        <span class="info">：{{userBankAccountInfo.bankAccount}}</span>
                    </div>
                    <div class="list">
                        <span class="title">金額幣別</span>
                        <span class="info">：{{userBankAccountInfo.currencyType}}</span>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
        }
    },
    // mounted() {
    //     this.$analytics.logEvent('新增委託_ATM付款', { screen_name: '新增委託_ATM付款'})
    // },
    watch: {
        'modalStatus.walletStoredInfo': {
            handler: function (val) {
                if(val){
                    this.$store.dispatch('getUserBankAccountInfo')
                }
            },
            immediate: true
        }
    },
    methods: {
        closeModal: function (type) {
            this.$store.dispatch('setModalStatus', {state: false, type: 'walletStoredInfo'})
        },
    },
    computed: {
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
            userBankAccountInfo: 'GET_USER_BANK_ACCOUNT_INFO'
        })
    },
    components: {
        Modal,
    }
}
</script>
<style lang="scss"  >
    .info-modal{
        .modal-content{
            width: 456px;
            padding: 0 !important;
            .detail{
                align-items: unset !important;
                padding: 32px 0;
                h1{
                    margin: 0 auto;
                    margin-bottom: 24px;
                }
                .content{
                    padding: 0 32px;
                    h2{
                        font-size: 20px;
                        margin-bottom: 16px;
                        font-weight: 500;
                    }
                    .notice-title{
                        display: flex;
                        align-items: center;
                        font-size: 12px;
                        color: #676362;
                        margin-bottom: 4px;
                    }
                    .notice-content{
                        color: #ff9275;
                        margin-bottom: 16px;
                    }
                    .type{
                        display: flex;
                        align-items: center;
                        padding: 0 20px;
                        width: 121px;
                        height: 90px;
                        border-radius: 4px;
                        border: solid 1px#ff9275;
                        background-color: #fff;
                        line-height: 1.71;
                        color: #ff9275;
                        margin-right: 16px;
                        margin-bottom: 10px;
                        img{
                            margin-right: 10px;
                        }
                        .content-wrap{
                            .description{
                                font-size: 12px;
                            }
                        }
                    }
                    .list{
                        margin-bottom: 12px;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/modal/walletStoredInfo.vue